import { Stack } from '@mui/material';
import packageJSON from '../../package.json';
import StravaConnectImg from '../assets/connectWithStrava.png';
import PoweredBySTravaImg from '../assets/powered_by_strava.png';
import PreviewImage from '../assets/preview.png';
import StravaDashboardLogo from '../assets/strava-dashboard-logo.svg';
import SocialFollow from '../components/SocialFollow';
import { isProduction, netlifyUrl } from '../services';
import styles from './Authorization.module.css';

// secrets
const { VITE_CLIENT_ID: client_id } = import.meta.env;

// URLs
const baseUrl = isProduction ? netlifyUrl : 'http://127.0.0.1:5173/';
const redirect_uri = baseUrl + 'redirect';

// GET
const scope = 'read,profile:read_all,activity:read,activity:read_all';
const oauthURL = `https://www.strava.com/oauth/authorize?client_id=${client_id}&response_type=code&redirect_uri=${redirect_uri}&approval_prompt=auto&scope=${scope}`;

const { version } = packageJSON;

type FeattureProps = {
  icon: React.ReactNode;
  title: string;
  desc: string;
};

const Feature = ({ icon, title, desc }: FeattureProps) => (
  <div className={styles.feature}>
    <div className={styles.icon}>{icon}</div>
    <h4>{title}</h4>
    <p>{desc}</p>
  </div>
);

const Authorization = () => {
  return (
    <>
      <div className={styles.container}>
        {/* Header */}
        <header className={styles.header}>
          <div className={styles['header-content']}>
            <h1 className={styles.logo}>Strava Dashboard</h1>
            <nav className={styles.nav}>
              <a href="#features">
                <b>Fonctionnalités</b>
              </a>
              <a href="#gallery">
                <b>Aperçu</b>
              </a>
              <a href="#cta">
                <b>Commencer</b>
              </a>
            </nav>
          </div>
        </header>

        <Stack
          alignItems={'center'}
          justifyContent="center"
          spacing={2}
          width={'100%'}
        >
          <img width={250} src={StravaDashboardLogo} alt="logo" />
        </Stack>

        {/* Hero */}
        <section className={styles.hero}>
          <h2>Planifiez. Suivez. Progressez.</h2>
          <p>
            Une interface claire et intuitive pour vos entraînements
            hebdomadaires
          </p>
          <a className={styles.stravaConnectlink} href={oauthURL}>
            <img
              src={StravaConnectImg}
              alt="Connect Strava"
              className={styles.stravaConnectImg}
            />
          </a>
        </section>

        {/* Features */}
        <section id="features" className={styles.features}>
          <h3>Fonctionnalités clés</h3>
          <div className={styles['features-grid']}>
            <Feature
              icon="📅"
              title="Vue hebdomadaire"
              desc="Visualisez vos entraînements jour par jour, en un clin d'œil."
            />
            <Feature
              icon="📊"
              title="Statistiques dynamiques"
              desc="Distances, temps, évolution hebdo. Tout est centralisé."
            />
            <Feature
              icon="🎯"
              title="Filtres intelligents"
              desc="Affichez uniquement les activités qui vous intéressent (running, vélo, etc.)."
            />
          </div>
        </section>

        {/* Gallery */}
        <section id="gallery" className={styles.gallery}>
          <h3>Un aperçu de l'interface</h3>
          <img src={PreviewImage} alt="UI Preview" />
        </section>

        {/* Call to Action */}
        <section id="cta" className={styles.cta}>
          <h3>Prêt à organiser vos entraînements ?</h3>
          <p>
            Rejoignez les sportifs qui planifient mieux pour performer plus.
          </p>
          <a href="#" className={styles['btn-secondary']}>
            Créer un compte
          </a>
        </section>

        {/* Footer */}
        <footer className={styles.footer}>
          © 2025 Strava Dashboard — Tous droits réservés — Version{' '}
          <b>{version}</b>
        </footer>
      </div>

      <SocialFollow>
        <img width={300} src={PoweredBySTravaImg} alt="powered by Strava" />
      </SocialFollow>
    </>
  );
};

export default Authorization;
